




































import { Component, Mixins, Prop } from "vue-property-decorator";
import { GatewayTypes } from "@/data/enums";
import { IPaymentDetail } from "@/models/paymentDetails";
import { IClient } from "@/models/clients";
import ClientMixin from "@/mixins/clientMixin";

@Component
export default class PaymentMethodsListRow extends Mixins(ClientMixin) {
  // Props

  @Prop({ required: true })
  public method!: IPaymentDetail & {
    client: IClient;
  };

  public get clientName() {
    return this.getClientName({
      client: this.method.client,
      clientId: this.method.client_id,
      orEmail: true
    });
  }

  public get isCard() {
    return this.method.gateway.type === GatewayTypes.CARD;
  }

  public get cardSrc() {
    return this.method.card_type
      ? `/assets/images/interface/payment-providers/${this.method.card_type}.svg`
      : null;
  }

  public get cardType() {
    return this.$_.get(
      this.$_.find(
        this.method.gateway.card_types || [],
        type => type.code === this.method.card_type
      ),
      "name",
      this.$_.startCase((this.method?.card_type || "").replace(/-/, " "))
    );
  }

  public get cardLast4() {
    return this.method.card_last4;
  }

  public get paymentMethodRoute() {
    return {
      name: "adminClientPaymentMethods",
      params: {
        clientId: this.method.client_id
      }
    };
  }
}
